import * as React from 'react';

import StartForm from './Start';
import MonitoringForm from './Monitoring';
import { formDataByType } from 'Utility/documentHandling';

const InflammatoryDiseaseActivityForm = ({
  formData,
  document,
  viewing,
  relapseDocs,
  mriDocs,
}: IOwnProps): React.JSX.Element | null => {
  switch (document._type) {
    case 'inflammatoryDiseaseActivityStart':
      return (
        <StartForm
          formData={formDataByType(formData, document)}
          viewing={viewing}
          doc={document}
          relapseDocs={relapseDocs}
          mriDocs={mriDocs}
        />
      );
    case 'inflammatoryDiseaseActivityMonitoring':
      return (
        <MonitoringForm
          formData={formDataByType(formData, document)}
          viewing={viewing}
          doc={document}
          relapseDocs={relapseDocs}
          mriDocs={mriDocs}
        />
      );
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData<
    IDocumentWithTypeV2<'inflammatoryDiseaseActivityStart' | 'inflammatoryDiseaseActivityMonitoring'>
  >;
  document: IDocumentWithTypeV2<
    'inflammatoryDiseaseActivityStart' | 'inflammatoryDiseaseActivityMonitoring' | 'relapse' | 'mri'
  >;
  viewing?: string;
  relapseDocs: IDocumentWithTypeV2<'relapse'>[];
  mriDocs: IDocumentWithTypeV2<'mri'>[];
}

export default InflammatoryDiseaseActivityForm;
